import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<SelectedChoice @item={{this.item}} @selectKit={{this.selectKit}} @extraClass={{this.extraClass}}>\n  {{this.badge}}\n</SelectedChoice>", {
  moduleName: "select-kit/components/selected-choice-category.hbs"
});